import { ROUTE_PATH as STORES_PATH } from '@/features/storesPage/consts';

export const createEditStoreLink = storeId => `${STORES_PATH}/${storeId}/edit`;
